/* eslint-disable consistent-return */
/* eslint-disable no-param-reassign */
/* eslint-disable no-restricted-syntax */

/**
 * Disabling these set of rules for the file.
 * TODO: will work with Jake to figure this out and remove all the disabled rules
 */
const objectAccessor = (object: any, inputAccessorString: string) => {
  let accessorString = inputAccessorString.replace(/\[(\w+)]/g, '.$1'); // convert indexes to properties
  accessorString = accessorString.replace(/^\./, ''); // strip a leading dot
  const a = accessorString.split('.');
  for (const key of a) {
    if (key in object) {
      object = object[key];
    } else {
      return;
    }
  }
  return object;
};

export default objectAccessor;
